var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0C35.683 0 46 10.318 46 23C46 35.683 35.683 46 23 46C10.317 46 0 35.683 0 23C0 10.318 10.317 0 23 0Z",
    fill: "#3186D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.248 15.678H14.488V12.916H10.808V15.678H8.047V19.358H10.808V22.12H14.488V19.358H17.248V15.678Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.204 33.3297H11.796C9.21203 33.3297 7.11703 31.2347 7.11603 28.6507C7.11603 26.0667 9.21303 23.9707 11.797 23.9707H19.205L19.204 33.3297Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.481 32.4757C28.688 33.0897 27.696 33.4547 26.617 33.4547H11.797C9.21303 33.4547 7.11603 31.3587 7.11603 28.7757C7.11603 26.1917 9.21303 24.0957 11.797 24.0957H21.173",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.746 26.1048C11.278 25.8048 11.891 25.6338 12.544 25.6338H17.131",
    stroke: "#3186D1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88403 29.2949C8.88403 28.9019 8.94603 28.5249 9.06003 28.1709",
    stroke: "#3186D1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.653 26.8444L20.415 21.6064C18.588 19.7774 18.588 16.8144 20.415 14.9874C22.241 13.1604 25.206 13.1604 27.034 14.9874L32.272 20.2254L25.653 26.8444Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.514 25.4674C39.34 27.2944 39.34 30.2584 37.514 32.0854C35.688 33.9114 32.722 33.9114 30.895 32.0854L20.415 21.6064C18.588 19.7774 18.588 16.8144 20.415 14.9874C22.241 13.1604 25.206 13.1604 27.034 14.9874L37.514 25.4674Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.871 15.6641C25.458 15.8291 26.013 16.1411 26.475 16.6021L29.716 19.8451",
    stroke: "#3186D1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.298 16.6022C21.565 16.3352 21.862 16.1182 22.18 15.9512",
    stroke: "#3186D1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.0de988707f679777ef47d757589ab028.svg";
export { ForwardRef as ReactComponent };